export default __webpack_public_path__ + "static/media/four.c39d3ee9.png";